import { getStoreState } from '@/redux/stores'
import { UserRoleNames } from '@/types/permissions'
import { UserRole } from '@/types/user'

export function hasUserRole(userRoleName: string) {
	const myUserRoles = getStoreState().myUserRoles
	return Boolean(myUserRoles?.findIndex((r: UserRole) => Boolean(r?.role && r.role.name === userRoleName)) >= 0)
}

export function isSupportUser() {
	return hasUserRole(UserRoleNames.SupportUser)
}

export function isBookerForOthers() {
	return hasUserRole(UserRoleNames.ManageBookings)
}
